import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bit-percentage',
  templateUrl: './percentage.component.html',
  styleUrls: ['./percentage.component.scss']
})
export class PercentageComponent implements OnInit {

  @Input() value = 0;

  get isPositive() {
    return this.value > 0;
  }

  get absoluteValue() {
    return Math.abs(this.value);
  }

  constructor() { }

  ngOnInit(): void {
  }

}
